import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../components/Student/StuStyles/StudentProfile.css";
import ApiService from "../nhrc_apis/ApiService";

const { HrProfileAPI } = ApiService;

const HremployeeRegistration = () => {

  const [personal, setPersonal]         = useState({});
  const [professional, setProfessional] = useState({});
  const [documents, setDocuments]       = useState({});
  const [loading, setLoading]           = useState(true);
  const [error, setError]               = useState(null);

  useEffect(() => {
    fetchHrProfile();
  }, []);

  const fetchHrProfile = async () => {
    try {
      setLoading(true);
      setError(null);

      const res              = await HrProfileAPI.getProfile();
      const responseData     = res?.data || {};
      const personalData     = responseData.personal_details     || {};
      const professionalData = responseData.professional_details || {};
      const docsData         = responseData.documents            || {};

      setPersonal(personalData);
      setProfessional(professionalData);
      setDocuments(docsData);

    } catch (err) {
      if (err?.response?.status === 401) {
        setError("Session expired. Please login again.");
      } else if (err?.response?.status === 403) {
        setError("Access denied. You do not have permission to view this profile.");
      } else {
        setError("Failed to load profile. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="container mt-5 text-center">
        <div className="spinner-border text-primary" role="status"></div>
        <h5 className="mt-3">Loading Employee Profile...</h5>
      </div>
    );
  }

  if (error) {
    return (
      <div className="container mt-5">
        <div className="alert alert-danger text-center">
          <h5>{error}</h5>
          <button className="btn btn-primary mt-2" onClick={fetchHrProfile}>
            Retry
          </button>
        </div>
      </div>
    );
  }

  const websiteUrl = professional.company_website && professional.company_website !== "string"
    ? professional.company_website
    : null;

  const idCardFrontUrl = documents.id_card_front && documents.id_card_front !== ""
    ? "https://nhrc.onrender.com/" + documents.id_card_front
    : null;

  const idCardBackUrl = documents.id_card_back && documents.id_card_back !== ""
    ? "https://nhrc.onrender.com/" + documents.id_card_back
    : null;

  return (
    <div className="container student-profile-container mt-5 mb-5">

      {/* HEADER */}
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h4 className="fw-bold mt-3">EMPLOYEE PROFILE</h4>
      </div>

      {/* =========================================
          PERSONAL DETAILS
      ========================================= */}
      <div className="card p-4 mb-4 shadow-sm">
        <h5 className="section-title text-center mb-4">Personal Details</h5>

        <div className="text-center mb-4">
          <img
            src={
              personal.profile_pic && personal.profile_pic !== "string"
                ? personal.profile_pic
                : "https://dummyimage.com/150x150/cccccc/000000&text=No+Image"
            }
            alt="Profile"
            style={{
              width: "150px",
              height: "150px",
              objectFit: "cover",
              borderRadius: "10px",
              border: "2px solid #dee2e6",
            }}
            onError={(e) => {
              e.target.src = "https://dummyimage.com/150x150/cccccc/000000&text=No+Image";
            }}
          />
        </div>

        <div className="row g-3">

          <div className="col-md-4">
            <label className="form-label fw-semibold">Membership ID</label>
            <input className="form-control bg-light" value={personal.membership_id || "—"} readOnly />
          </div>

          <div className="col-md-4">
            <label className="form-label fw-semibold">Full Name</label>
            <input className="form-control bg-light" value={personal.full_name || "—"} readOnly />
          </div>

          <div className="col-md-4">
            <label className="form-label fw-semibold">Email</label>
            <input className="form-control bg-light" value={personal.email || "—"} readOnly />
          </div>

          <div className="col-md-4">
            <label className="form-label fw-semibold">Mobile</label>
            <input className="form-control bg-light" value={personal.mobile || "—"} readOnly />
          </div>

          <div className="col-md-4">
            <label className="form-label fw-semibold">Gender</label>
            <input className="form-control bg-light" value={personal.gender || "—"} readOnly />
          </div>

          <div className="col-md-4">
            <label className="form-label fw-semibold">Date of Birth</label>
            <input className="form-control bg-light" value={personal.dob || "—"} readOnly />
          </div>

          <div className="col-md-4">
            <label className="form-label fw-semibold">Blood Group</label>
            <input className="form-control bg-light" value={personal.blood_group || "—"} readOnly />
          </div>

          <div className="col-md-4">
            <label className="form-label fw-semibold">State</label>
            <input className="form-control bg-light" value={personal.state || "—"} readOnly />
          </div>

          <div className="col-md-4">
            <label className="form-label fw-semibold">District</label>
            <input className="form-control bg-light" value={personal.district || "—"} readOnly />
          </div>

          <div className="col-md-4">
            <label className="form-label fw-semibold">Pincode</label>
            <input className="form-control bg-light" value={personal.pincode || "—"} readOnly />
          </div>

          <div className="col-md-4">
            <label className="form-label fw-semibold">Candidate Type</label>
            <input className="form-control bg-light" value={personal.candidate_type || "—"} readOnly />
          </div>

          <div className="col-md-4">
            <label className="form-label fw-semibold">Status</label>
            <input
              className="form-control bg-light"
              value={personal.status || "—"}
              readOnly
              style={{
                color: personal.status === "approved" ? "green" : personal.status === "rejected" ? "red" : "inherit",
                fontWeight: "600",
              }}
            />
          </div>

          <div className="col-md-4">
            <label className="form-label fw-semibold">Member Since</label>
            <input
              className="form-control bg-light"
              value={
                personal.created_at
                  ? new Date(personal.created_at).toLocaleDateString("en-IN", {
                      day: "2-digit",
                      month: "short",
                      year: "numeric",
                    })
                  : "—"
              }
              readOnly
            />
          </div>

        </div>
      </div>

      {/* =========================================
          PROFESSIONAL DETAILS
      ========================================= */}
      <div className="card p-4 mb-4 shadow-sm">
        <h5 className="section-title text-center mb-4">Professional Details</h5>

        <div className="row g-3">

          <div className="col-md-4">
            <label className="form-label fw-semibold">Employee ID</label>
            <input className="form-control bg-light" value={professional.employee_id || "—"} readOnly />
          </div>

          <div className="col-md-4">
            <label className="form-label fw-semibold">Designation</label>
            <input className="form-control bg-light" value={professional.designation || "—"} readOnly />
          </div>

          <div className="col-md-4">
            <label className="form-label fw-semibold">Department</label>
            <input className="form-control bg-light" value={professional.department || "—"} readOnly />
          </div>

          <div className="col-md-4">
            <label className="form-label fw-semibold">Organization Name</label>
            <input className="form-control bg-light" value={professional.organization_name || "—"} readOnly />
          </div>

          <div className="col-md-4">
            <label className="form-label fw-semibold">Official Email</label>
            <input className="form-control bg-light" value={professional.official_email || "—"} readOnly />
          </div>

          <div className="col-md-4">
            <label className="form-label fw-semibold">User Email</label>
            <input className="form-control bg-light" value={professional.user_email || "—"} readOnly />
          </div>

          <div className="col-md-4">
            <label className="form-label fw-semibold">Industry</label>
            <input className="form-control bg-light" value={professional.industry || "—"} readOnly />
          </div>

          <div className="col-md-4">
            <label className="form-label fw-semibold">Experience (Years)</label>
            <input
              className="form-control bg-light"
              value={
                professional.experience !== undefined && professional.experience !== null
                  ? String(professional.experience)
                  : "—"
              }
              readOnly
            />
          </div>

          <div className="col-md-4">
            <label className="form-label fw-semibold">Working Location</label>
            <input className="form-control bg-light" value={professional.working_location || "—"} readOnly />
          </div>

          <div className="col-md-4">
            <label className="form-label fw-semibold">Company Website</label>
            <input className="form-control bg-light" value={professional.company_website || "—"} readOnly />
            {websiteUrl && (
              <small className="mt-1 d-inline-block">
                <span
                  style={{ color: "blue", cursor: "pointer", textDecoration: "underline" }}
                  onClick={() => window.open(websiteUrl, "_blank")}
                >
                  Open Website
                </span>
              </small>
            )}
          </div>

          <div className="col-md-4">
            <label className="form-label fw-semibold">Company Strength</label>
            <input className="form-control bg-light" value={professional.company_strength || "—"} readOnly />
          </div>

          <div className="col-md-4">
            <label className="form-label fw-semibold">Referral ID</label>
            <input className="form-control bg-light" value={professional.referral_id || "—"} readOnly />
          </div>

        </div>
      </div>

      {/* =========================================
          DOCUMENTS
      ========================================= */}
      <div className="card p-4 mb-5 shadow-sm">
        <h5 className="section-title text-center mb-4">Documents</h5>

        <div className="row g-4">

          <div className="col-md-6">
            <label className="form-label fw-semibold">ID Card Front</label>
            {idCardFrontUrl ? (
              <div>
                <input
                  className="form-control bg-light mb-2"
                  value={documents.id_card_front}
                  readOnly
                />
                <img
                  src={idCardFrontUrl}
                  alt="ID Card Front"
                  style={{
                    width: "100%",
                    maxWidth: "300px",
                    height: "180px",
                    objectFit: "cover",
                    borderRadius: "8px",
                    border: "1px solid #dee2e6",
                  }}
                  onError={(e) => {
                    e.target.style.display = "none";
                  }}
                />
              </div>
            ) : (
              <div className="form-control bg-light text-muted">
                No document uploaded
              </div>
            )}
          </div>

          <div className="col-md-6">
            <label className="form-label fw-semibold">ID Card Back</label>
            {idCardBackUrl ? (
              <div>
                <input
                  className="form-control bg-light mb-2"
                  value={documents.id_card_back}
                  readOnly
                />
                <img
                  src={idCardBackUrl}
                  alt="ID Card Back"
                  style={{
                    width: "100%",
                    maxWidth: "300px",
                    height: "180px",
                    objectFit: "cover",
                    borderRadius: "8px",
                    border: "1px solid #dee2e6",
                  }}
                  onError={(e) => {
                    e.target.style.display = "none";
                  }}
                />
              </div>
            ) : (
              <div className="form-control bg-light text-muted">
                No document uploaded
              </div>
            )}
          </div>

        </div>
      </div>

    </div>
  );
};

export default HremployeeRegistration;